<template>
<div class="chapter">
<div class="inner_page">
<p class="C358"><strong><a id="page_14">THE WORLD</a></strong></p><a id="page_14">
<p class="C359">Key locations visited in the book are labelled below in CAPITALS.</p>
<p class="C251"><img alt="" src="html/images/14_1.png"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_The_World__key_locations_visited.vue?ab3e4f94